export const GET_LOYAL_APPLICANTS_REQUEST = "GET_LOYAL_APPLICANTS_REQUEST";
export const GET_LOYAL_APPLICANTS_RESPONSE = "GET_LOYAL_APPLICANTS_RESPONSE";
export const BULK_REMOVE_LOYAL_APPLICANTS_REQUEST =
  "BULK_REMOVE_LOYAL_APPLICANTS_REQUEST";
